// test2727
(2727 && 0);
